interface OrientationRadioGroupProps {
  orientation: string;
  options: { name: string; key: string }[];
  onChange: (key: string) => void;
  disabled?: boolean; // New prop to control disabled state
  style?: React.CSSProperties; // Optional style prop for additional customization
}

export const OrientationRadioGroup = ({
  orientation,
  options,
  onChange,
  disabled = false,
  style = {},
}: OrientationRadioGroupProps) => {
  return (
    <div
      className="radioButtons"
      style={{
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        ...style, // Allow additional styling from parent
      }}
    >
      {options.map((item) => {
        const isSelected = item.key === orientation;
        return (
          <div
            className={isSelected ? 'radioButtonSelected' : 'radioButton'}
            onClick={() => !disabled && onChange(item.key)} // Only trigger if not disabled
            key={item.key}
            style={{
              backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
              cursor: disabled ? 'not-allowed' : isSelected ? 'auto' : 'pointer',
              fontWeight: isSelected ? '600' : 'normal',
              color: '#404040',
            }}
          >
            {item.name}
          </div>
        );
      })}
    </div>
  );
};
